import { render, staticRenderFns } from "./frontCotizacionContainer.vue?vue&type=template&id=799cff68&"
import script from "./frontCotizacionContainer.vue?vue&type=script&lang=js&"
export * from "./frontCotizacionContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontCotizacionContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports